import { render, staticRenderFns } from "./OnlineConsultDrawer.vue?vue&type=template&id=bbab74f8&scoped=true&"
import script from "./OnlineConsultDrawer.vue?vue&type=script&lang=js&"
export * from "./OnlineConsultDrawer.vue?vue&type=script&lang=js&"
import style0 from "./OnlineConsultDrawer.vue?vue&type=style&index=0&id=bbab74f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbab74f8",
  null
  
)

export default component.exports